export const isAlphaNumeric = value => /^[a-zA-Z0-9]*$/.test(value);
export const isNumeric = value => /^[0-9]*$/.test(value);
